import React from "react"
import { Modal } from "react-bootstrap"
import { map } from "lodash"

import { TimeTable } from "components/molecules/table/timeTable"
import { TIME_TABLE_ATTENTION } from "config/const"

type Props = {
  show: boolean
  onHide: () => void
}

export const TimeTableModal = (props: Props) => {
  return (
    <Modal {...props} className="panel-time-table" size="xl">
      <Modal.Header>
        <div className="header-title">取引時間</div>
        <div className="header-nav-icon-col">
          <div
            className="header-icon ripple"
            data-izimodal-close
            onClick={props.onHide}
          >
            <i className="material-icons">close</i>
          </div>
        </div>
      </Modal.Header>
      <Modal.Body>
        <div className="modal-body-content">
          <TimeTable />
          <div className="message-col">
            <ul className="attention-message-list">
              {TIME_TABLE_ATTENTION.map((row, i) => (
                <li key={i}>
                  {!!row.cls ? <div className={row.cls} /> : null}
                  {typeof row.msg === "string" ? (
                    row.msg
                  ) : (
                    <div>
                      {map(row.msg, (msg: string, j: number) => (
                        <div key={j}>{msg}</div>
                      ))}
                    </div>
                  )}
                </li>
              ))}
            </ul>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <div className="modal-bottom-btn-row">
          <div
            className="btn btn-outline ripple"
            data-izimodal-close
            onClick={props.onHide}
          >
            閉じる
          </div>
        </div>
      </Modal.Footer>
    </Modal>
  )
}
